import { useDisabled, type DisabledState } from './disabled.tsx'

import './form.css'

/**
 * 토글 스위치 — 와이어프레임 `tog()` 1026행.
 * 와이어프레임은 `<div class="tog">` 로 `role="switch"` 가 없다(§11-4-6). 여기서는 붙인다.
 *
 * ⚠ 설정 값 변경은 서버가 주체다. 낙관적으로 먼저 켜지 마라 — `checked` 는 서버 값이다(DP-04).
 */
export type SwitchProps = {
  checked: boolean
  onChange?: ((checked: boolean) => void) | undefined
  /** 접근성 이름. 필수 */
  label: string
  /** 고칠 수 없는 «값». 🔴 흐려지지 않는다 — 사정은 `TextInput` 머리말 */
  readOnly?: boolean | undefined
  /**
   * **섞임**(묶음 안 일부만 켜짐) — 손잡이가 가운데 · 옅은 강조 면으로 선다(`.a-switch[data-mixed]`). `checked` 는 `false` 로 둔다.
   * ⚠ `role="switch"` 는 `aria-checked="mixed"` 를 받지 않는다 — 섞임은 부르는 쪽이 접근 이름(`label`)에 같이 적는다
   */
  mixed?: boolean | undefined
} & DisabledState

export function Switch({
  checked,
  onChange,
  label,
  readOnly,
  mixed,
  disabled,
  disabledReason,
}: SwitchProps) {
  const isReadOnly = readOnly === true
  const { isDisabled, ariaProps, reasonNode } = useDisabled(
    isReadOnly ? false : disabled,
    disabledReason,
  )

  return (
    <>
      <button
        aria-checked={checked}
        aria-label={label}
        aria-readonly={isReadOnly ? true : undefined}
        className="a-switch"
        data-mixed={mixed === true && !checked ? 'true' : undefined}
        onClick={isDisabled || isReadOnly ? undefined : () => onChange?.(!checked)}
        role="switch"
        type="button"
        {...ariaProps}
      />
      {reasonNode}
    </>
  )
}
